module.exports = __webpack_public_path__ + "assets/img/922198.b26f15e7.jpg";